import styled from 'styled-components';
import { ColorDLS } from '../../styling/color';
import React from 'react';
import { Tooltip } from '@dls/react-core';
import { format, subDays } from 'date-fns';

interface Activity {
  data: boolean[];
}

const StyledContainer = styled.div`
  display: flex;

  div:not(:first-child) {
    margin-left: 4px;
  }
`;

const StyledDataBoxWithData = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 2px;
  background-color: ${ColorDLS.Blue75};
  border: 1px solid ${ColorDLS.Blue85};
`;

const StyledDataBoxWithoutData = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 2px;
  background-color: ${ColorDLS.Gray05};
  border: 1px solid ${ColorDLS.Gray15};
`;

export const ActivityContainer: React.FC<Activity> = ({ data }) => {
  return (
    <StyledContainer>
      {[...Array(15)].map((_, i) => (
        <Tooltip key={i} title={format(subDays(new Date(), 14 - i), 'dd-MM-yyyy')} arrow>
          {data && data[i] ? (
            <StyledDataBoxWithData key={i} />
          ) : (
            <StyledDataBoxWithoutData key={i} />
          )}
        </Tooltip>
      ))}
    </StyledContainer>
  );
};
